import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NickyButtonComponent } from 'src/app/components/form/nicky-button/nicky-button.component';

import { PaymentStore } from '../../store/payment-report.store';
import { WizardReportStore } from '../../store/wizard-report.store';

@Component({
  selector: 'app-outdated-quote',
  imports: [MatIcon, NickyButtonComponent, TranslateModule],
  templateUrl: './outdated-quote.component.html',
})
export class OutdatedQuoteComponent {
  protected paymentStore = inject(PaymentStore);
  protected wizardReportStore = inject(WizardReportStore);

  userWillPayWithNewQuote() {
    this.paymentStore.setIsResumePayment(false);

    this.wizardReportStore.setStep('payment');
  }

  userAlreadyPaid() {
    this.paymentStore.updatePaymentDetails({ shouldKeepQuote: true });
    this.wizardReportStore.setStep('payment');
  }
}
